import { render, staticRenderFns } from "./PatternSideBar.vue?vue&type=template&id=6d905ea9&"
import script from "./PatternSideBar.vue?vue&type=script&lang=js&"
export * from "./PatternSideBar.vue?vue&type=script&lang=js&"
import style0 from "./PatternSideBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports